import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { Button, Space, Table } from 'antd';
import { FC, useState } from 'react';
import {
	getSessionDocumentList,
	OCRBankStatement,
	OCRSessionDocumentListNormalized,
} from '@/libs/fleet-api/services/ocr';
import { useQuery } from '@tanstack/react-query';

type ModalData = {
	ocrId: number;
};

export const useOCRDocumentStatusModal = () => {
	const [modalData, setModalData] = useState<ModalData>();

	return {
		data: modalData,
		isOpen: Boolean(modalData),
		open: (data: ModalData) => {
			setModalData(data);
		},
		close: () => setModalData(undefined),
	};
};

const OCRDocumentStatusModal: FC<
	ReturnType<typeof useOCRDocumentStatusModal>
> = (props) => {
	const ocrId = props.data?.ocrId ?? 0;
	const { data, isFetching, isLoading } = useQuery({
		queryKey: ['getSessionDocumentList', ocrId] as const,
		queryFn: ({ queryKey }) => {
			const [, id] = queryKey;
			if (!id) return null;
			return getSessionDocumentList(ocrId);
		},
	});
	console.log('ini data document status', data);

	const normalizeDatasource = (data: {
		bankStatements: OCRBankStatement[];
	}) => {
		const transformed: OCRSessionDocumentListNormalized[] =
			data.bankStatements?.flatMap((bank: OCRBankStatement) => [
				...(bank.passStatements
					? bank.passStatements.map((file: string) => ({
							bankName: bank.bankName,
							fileName: file,
							status: 'Pass',
						}))
					: []),
				...(bank.failStatements
					? bank.failStatements.map((file: string) => ({
							bankName: bank.bankName,
							fileName: file,
							status: 'Fail',
						}))
					: []),
				...(bank.remainingStatements
					? bank.remainingStatements.map((file: string) => ({
							bankName: bank.bankName,
							fileName: file,
							status: 'Processing',
						}))
					: []),
			]);

		return transformed?.sort((a, b) => a.fileName.localeCompare(b.fileName));
	};

	const dataSource = data ? normalizeDatasource(data.data) : [];

	return (
		<FleetModal
			open={props.isOpen}
			width={940}
			closable={false}
			buttonPosition="end"
			footer={<Button onClick={() => props.close()}>BACK</Button>}
		>
			<Space
				direction="vertical"
				style={{ display: 'flex' }}
				size={'large'}
			>
				<FleetTitle>Proses Pengecekan OCR Rekening</FleetTitle>
				<Table
					bordered
					loading={isFetching || isLoading}
					pagination={false}
					scroll={{ x: 'max-content' }}
					dataSource={
						dataSource?.map((item, i) => {
							return {
								...item,
								key: i,
							};
						}) ?? []
					}
					columns={[
						{
							title: 'Nama Dokumen',
							render: (_, record) => record.fileName,
						},
						{
							title: 'Status Process',
							render: (_, record) => (
								<span
									style={{
										color:
											record.status === 'Pass'
												? '#48A11E'
												: record.status === 'Processing'
													? '#C59B04'
													: 'red',
									}}
								>
									{record.status}
								</span>
							),
						},
					]}
				/>
			</Space>
		</FleetModal>
	);
};

export default OCRDocumentStatusModal;
